import {Link03Icon, LinkBroken01Icon} from '@/components/ui/icon/Icon'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {StyledDiagnosisCodesLinkToggle} from '@/features/projects/components/diagnosis-codes-link-toggle/style'
import {useTranslation} from '@/translations/i18n'

interface DiagnosisCodesLinkToggleProps {
    isLinked: boolean
    /** False from ICD10_MANDATORY_FROM: the ICD-9 can then only be filled from the ICD-10. */
    isEditable?: boolean
    onToggle: (isLinked: boolean) => void
}

/**
 * Toggle sitting between the ICD-9 and the ICD-10 select. Closed chain: picking one code fills the
 * other from the transcoding. Open chain: the two codes are picked independently.
 */
export const DiagnosisCodesLinkToggle = ({isLinked, isEditable = true, onToggle}: DiagnosisCodesLinkToggleProps) => {
    const {t} = useTranslation()

    const action = isLinked ? t('projects:diagnosis_codes_unlink_action') : t('projects:diagnosis_codes_link_action')
    const hint = !isEditable
        ? t('projects:diagnosis_codes_link_locked_hint')
        : isLinked
          ? t('projects:diagnosis_codes_unlink_hint')
          : t('projects:diagnosis_codes_link_hint')

    return (
        <Tooltip content={hint} variant="light" maxWidth={280} triggerProps={{asChild: true}}>
            {/* The tooltip hangs on the wrapper, not on the button: a disabled button swallows the
                pointer events Radix listens to, and the locked state is the one most in need of an
                explanation. The wrapper also sits the toggle on the input line of the row, below the
                labels of the two selects. */}
            <span style={{display: 'inline-flex', alignSelf: 'flex-end', flex: '0 0 auto'}}>
                <StyledDiagnosisCodesLinkToggle
                    $isLinked={isLinked}
                    type="button"
                    variant="ghost"
                    shape="square"
                    aria-label={action}
                    aria-pressed={isLinked}
                    disabled={!isEditable}
                    onClick={() => onToggle(!isLinked)}
                >
                    {isLinked ? <Link03Icon /> : <LinkBroken01Icon />}
                </StyledDiagnosisCodesLinkToggle>
            </span>
        </Tooltip>
    )
}
